/*
    创建者：shuxiaokai
    创建时间：2019-12-24 16:05
    模块名称：xxxx
    备注：xxxx
*/
<template>
    <div class="config-pane">
        <el-tabs v-model="activeName">
            <el-tab-pane label="组件" name="widget">
                <widget-config></widget-config>
            </el-tab-pane>
            <el-tab-pane label="配置" name="config">
                <data-config></data-config>
            </el-tab-pane>
            <el-tab-pane label="样式" name="style">
                <style-config></style-config>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import widgetConfig from "./widget-config/widget-config"
import dataConfig from "./data-config/data-config"
import styleConfig from "./style-config/style-config"
export default {
    components: {
        "widget-config": widgetConfig,
        "data-config": dataConfig,
        "style-config": styleConfig,
    },
    data() {
        return {
        };
    },
    computed: {
        activeName: {
            get() {
                return this.$store.state.wOptions.activeState;
            },
            set(val) {
                this.$store.commit("changeWidgetActiveState", val);
            }
        }
    },
    created() {

    },
    methods: {

    }
};
</script>



<style lang="scss">
    .config-pane {
        padding-left: size(20);
        width: size(600);
        background: $gray-100;
        box-shadow: $box-shadow;

        // user-select: none;
        .el-tabs__header {
            margin: 0;
        }
    }
</style>
